// build-in library

import { useSelector } from 'react-redux';
import { HasPermission } from '@/components/Permission/HasPermission';
import CardWrapper from '@/components/UI/CardWrapper';
//import TotalUnitsInDevelopments from "components/Widgets/TotalUnitsInDevelopmentWidget";
//import TotalForSaleUnitsWidget from "components/Widgets/TotalForSaleUnitsWidget";
//import TotalAffdForSaleUnitsWidget from "components/Widgets/TotalAffdForSaleUnitsWidgets";
//import TotalAffdRentalUnitsWidget from "components/Widgets/TotalAffdRentalUnitsWidget";
//import TotalMarketRentalUnits from "components/Widgets/TotalMarketRentalUnits";
//import AvgSalesPriceAffordableWidget from "components/Widgets/AvgSalesPriceAffordableWidget";
import CityInvestmentWidget from '@/components/Widgets/CityInvestmentWidget';
import { DashboardName, Widget } from '@/components/Widgets/constants.tsx';
import DevelopersInvestmentWidget from '@/components/Widgets/DevelopersInvestmentWidget';
import DevelopmentPipelineWidget from '@/components/Widgets/DevelopmentPipelineWidget';
import DistrictImpactWidget from '@/components/Widgets/DistrictImpactWidget';
import NewConstructionSummary from '@/components/Widgets/NewConstructionSummaryWidget';
import ProgrammaticSummary from '@/components/Widgets/ProgrammaticSummaryWidget';
import SourceSpentWidget from '@/components/Widgets/SourceSpentWidget';
import StatusWidget from '@/components/Widgets/StatusWidget';
import TotalProgramsWidget from '@/components/Widgets/TotalProgramsWidget';
import TotalProjectSourcesWidget from '@/components/Widgets/TotalProjectSourcesWidget';
import TotalProjectUsesWidget from '@/components/Widgets/TotalProjectUsesWidget';
//Services
import { useDashboardWidgetsList } from '@/hooks/ReactQueryHooks/useDashboardQuery';
import { authSelector } from '@/store';
//Custom Components
import DashboardWidget from '../../../components/DashboardWidget';
import ConstructionTypeWidget from '../../../components/Widgets/ConstructionTypeWidget';
import NeighborhoodImpactWidget from '../../../components/Widgets/NeighborhoodImpactWidget';
import ProjectBudgetSummaryWidget from '../../../components/Widgets/ProjectBudgetSummaryWidget';
import ProjectLocationWidget from '../../../components/Widgets/ProjectLocationWidget';
import ProjectStatusSummaryWidget from '../../../components/Widgets/ProjectStatusSummaryWidget';
import ProjectTypeWidget from '../../../components/Widgets/ProjectTypeWidget';
import RebuildLoansApprovedWidget from '../../../components/Widgets/RebuildLoansApprovedWidget';
import TotalDevelopersWidget from '../../../components/Widgets/TotalDevelopersWidget';
import TotalProjectsWidget from '../../../components/Widgets/TotalProjectsWidget';

import { shouldRenderWidget } from './constants';

function SherpaDashboard({ showButton = true }: { showButton?: boolean }) {
  const { data } = useSelector(authSelector);
  const { isWidgetUsed } = useDashboardWidgetsList({
    dashboard: DashboardName.SHERPA_DASHBOARD,
  });

  return (
    <div className='flex flex-col mx-auto space-y-4'>
      <div className='-mt-8'>
        <HasPermission of='MANAGE_WIDGETS'>{showButton && <DashboardWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}</HasPermission>
      </div>
      <section className='grid gap-6 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>
        {isWidgetUsed?.[Widget.REBUILD_LOANS_APPROVED] && shouldRenderWidget(Widget.REBUILD_LOANS_APPROVED, data?.account) && (
          <CardWrapper>
            <RebuildLoansApprovedWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.TOTAL_DEVELOPERS] && shouldRenderWidget(Widget.TOTAL_DEVELOPERS, data?.account) && (
          <CardWrapper>
            <TotalDevelopersWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {(data?.account === 'birminghamhousing' ||
          (shouldRenderWidget(Widget.TOTAL_PROGRAMS, data?.account) && isWidgetUsed?.[Widget.TOTAL_PROGRAMS])) && (
          <CardWrapper>
            <TotalProgramsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (
          <CardWrapper>
            <DevelopmentPipelineWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <CardWrapper>
            <DevelopersInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <CardWrapper>
            <CityInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.TOTAL_PROJECTS] && shouldRenderWidget(Widget.TOTAL_PROJECTS, data?.account) && (
          <CardWrapper>
            <TotalProjectsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}
      </section>
      <div className='mt-8'>
        {shouldRenderWidget(Widget.PROGRAMMATIC_SUMMARY, data?.account) && (
          <ProgrammaticSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </div>

      <div className='mt-8'>
        {shouldRenderWidget(Widget.PROJECTS_SPENDING_SUMMARY_REPORT, data?.account) && (
          <SourceSpentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </div>

      <section className='flex flex-col gap-8 mt-8'>
        {/* New Construction + District */}
        <div className='grid grid-cols-1 xl:grid-cols-2 gap-8 w-full'>
          {shouldRenderWidget(Widget.NEW_CONSTRUCTION_SUMMARY, data?.account) && (
            <div className='min-w-0 w-full'>
              <NewConstructionSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}

          {shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD_DISTRICT, data?.account) && (
            <div className='min-w-0 w-full'>
              <DistrictImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}
        </div>

        {/* Construction Type + Project Type */}
        <div className='flex flex-col gap-8 w-full min-w-0'>
          {isWidgetUsed?.[Widget.PROJECTS_BY_CONSTRUCTION_TYPE] &&
            shouldRenderWidget(Widget.PROJECTS_BY_CONSTRUCTION_TYPE, data?.account) && (
              <div className='min-w-0 w-full'>
                <ConstructionTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
              </div>
            )}

          {isWidgetUsed?.[Widget.PROJECTS_BY_PROJECT_TYPE] && shouldRenderWidget(Widget.PROJECTS_BY_PROJECT_TYPE, data?.account) && (
            <div className='min-w-0 w-full'>
              <ProjectTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}
        </div>

        {/* Neighborhood + Status */}
        <div className='grid grid-cols-1 xl:grid-cols-2 gap-8 w-full'>
          {isWidgetUsed?.[Widget.PROJECTS_BY_NEIGHBORHOOD] && shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD, data?.account) && (
            <div className='min-w-0 w-full'>
              <NeighborhoodImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}

          {isWidgetUsed?.[Widget.PROJECT_STATUS_SUMMARY] && shouldRenderWidget(Widget.PROJECT_STATUS_SUMMARY, data?.account) && (
            <div className='min-w-0 w-full'>
              <ProjectStatusSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}
        </div>

        {/* Project Location */}
        {isWidgetUsed?.[Widget.PROJECT_LOCATION] && shouldRenderWidget(Widget.PROJECT_LOCATION, data?.account) && (
          <div>
            <ProjectLocationWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
      </section>

      <section className='flex flex-col gap-8'>
        {shouldRenderWidget(Widget.PROJECTS_SUMMARY_REPORT, data?.account) && <StatusWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}

        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && isWidgetUsed?.[Widget.PROJECT_BUDGET_SUMMARY] && (
          <ProjectBudgetSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}

        {/*<div className="flex flex-wrap gap-8">*/}
        {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <div className='flex-1'>
            <TotalProjectSourcesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}

        {shouldRenderWidget(Widget.PROJECTS_BY_USES, data?.account) && (
          <div className='flex-1'>
            <TotalProjectUsesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        {/*</div>*/}
      </section>
    </div>
  );
}

export default SherpaDashboard;
